import { DatePicker, DateTimePicker, LocalizationProvider, TimePicker } from '@mui/lab';
import { Card, CardContent, Container, FormControlLabel, Modal, Switch, TextField } from '@mui/material';
import { format } from 'date-fns';
import React, { Dispatch, ReactChild, ReactChildren, SetStateAction, useEffect, useRef, useState } from 'react';
// import { useHistory } from 'react-router-dom';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import Swal from 'sweetalert2';
import { Title } from '../../Pages/Home/styles';
import api from '../../Services/ApiService';
import { Property } from '../../Utils/modelproperties';
import { StyledButton } from '../FormAgendamentoVirtual/styles';
import { FormItem } from './styles';
import ptbrLocal from 'date-fns/locale/pt-BR';

// import { Container } from './styles';
interface ICreateReadUpdateModal {
  id:number|undefined;
  route:string;
  modelProperties: Property[];
  opened: boolean;
  type: 'create' | 'read' | 'update';
  handleClose : () => void;
  updatedData: Dispatch<SetStateAction<boolean>>;
  children?:ReactChild | ReactChildren
}

const ReadOrUpdateModal: React.FC<ICreateReadUpdateModal> = ({id, route, handleClose, type, opened, modelProperties,updatedData, children}) => {
  const [model,setModel] = useState<any>();
  const formRef = useRef<HTMLFormElement>(null);
  // const history = useHistory();

  const handleSubmit = async (event:React.FormEvent) => {
    event.preventDefault();
    try {
      if(type === 'create'){
        console.log(model)
        await api.post(`/${route}`,model);
        handleClose();
        Swal.fire({
          title:'Sucesso!',
          text:'Criado com sucesso!',
          icon: 'success'
        }).then((result)=>{
          if(result.isConfirmed) updatedData(true);
        });
      }
      else{
        await api.put(`/${route}/${id}`,model);
        handleClose();
        Swal.fire({
          title:'Sucesso!',
          text:'Editado com sucesso!',
          icon: 'success'
        }).then((result)=>{
          if(result.isConfirmed) updatedData(true);
        });
    }
    } catch (error:any) {
      handleClose();
      Swal.fire({
        title:'Erro!',
        text:`${error.response.data}`,
        icon: 'error'
      })
    }
  }

  const fetchData = async () => {
    try {
      if(id===undefined){
        setModel(undefined);
        return;
      };
      if(id!==0){
        setModel(undefined)
        const {data} = await api.get(`/${route}/${id}`);
        setModel(data)
      }else{
        setModel({})
        modelProperties.forEach(property=>{
          if(property.default)
            setModel({...model, [property.id]:property.default})
        })
      }
    } catch (error) {
      console.error(error)
    }
  }


  useEffect(()=>{
    fetchData();
    // eslint-disable-next-line
  },[id])


  return (
    <>
      <Modal
        open={opened}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{overflow:'hidden'}}
        >
          <Container maxWidth="sm" sx={{padding:'5%'}}>
            <Card>
              <div style={{textAlign:'center'}}>
                {type === 'create'?
                  <Title>Criar</Title> :
                (type === 'read' ? 
                  <Title>Informações</Title> :
                  <Title>Editar</Title>
                )}
              </div>
              <CardContent>
                <form ref={formRef} onSubmit={handleSubmit}>
                  <div style={{padding:'5%',maxHeight:'50vh',overflow:'auto'}}>
                    {model && modelProperties.map((property,index)=>{
                      return (
                        <FormItem key={index}>
                          {property.type === 'boolean' ? (
                            <FormControlLabel 
                              labelPlacement="start"
                              control={<Switch
                                checked={property.default ? property.default : (model[property.id] ? model[property.id] : false)}
                                onChange={(event)=>setModel({...model, [property.id]:event.target.checked})}
                                disabled={property.disabled ? property.disabled : false}
                                />}
                              label={property.label}
                            />
                            
                          ):(
                            property.type === 'datetime-local' ? (
                              <LocalizationProvider dateAdapter={AdapterDateFns} locale={ptbrLocal}>
                                <DateTimePicker
                                  renderInput={(props) => 
                                    <TextField 
                                      {...props}
                                      style={{width:'100%'}} />
                                  }
                                  label={property.label}
                                  value={model[property.id] ? new Date(model[property.id]) : new Date()}
                                  onChange={(value)=>{
                                    const valueString = value ? format(value, "yyyy-MM-dd'T'HH:mm:00") : format(new Date(), "yyyy-MM-dd'T'HH:mm:00");
                                    setModel({...model, [property.id]: valueString})
                                  }}
                                />
                                </LocalizationProvider>
                            ):(
                              property.type === 'time' ? (
                                <LocalizationProvider dateAdapter={AdapterDateFns} locale={ptbrLocal}>
                                  <TimePicker
                                    label={property.label}
                                    value={model[property.id] ? new Date(model[property.id]) : null}
                                    onChange={(value) => {
                                      const valueString = value ? format(value, "yyyy-MM-dd'T'HH:mm:00") : format(new Date(), "yyyy-MM-dd'T'HH:mm:00");
                                      setModel({...model, [property.id]: valueString})
                                    }}
                                    renderInput={(params) => <TextField {...params} />}
                                  />
                                </LocalizationProvider>
                              ):(
                                property.type==='date' ?(
                                  <LocalizationProvider dateAdapter={AdapterDateFns} locale={ptbrLocal}>
                                    <DatePicker
                                      label={property.label}
                                      value={model[property.id] ? new Date(model[property.id]) : null}
                                      onChange={(value) => {
                                        const valueString = value ? format(value, "yyyy-MM-dd'T'00:00:00") : format(new Date(), "yyyy-MM-dd'T'00:00:00");
                                        setModel({...model, [property.id]: valueString})
                                      }}
                                      renderInput={(params) => <TextField {...params} />}
                                    />
                                  </LocalizationProvider>
                                ):(
                                  <TextField 
                                    multiline
                                    type={property.type}
                                    InputProps={{
                                      readOnly: type==='read'
                                    }}
                                    required={property.required ? property.required : false}
                                    label={property.label}
                                    value={model[property.id]? model[property.id] : ""} 
                                    onChange={(event)=>{setModel({...model, [property.id]:event.target.value})}}
                                    style={{width:'100%'}}
                                    disabled={property.disabled ? property.disabled : false}
                                  />
                                )
                              )
                            )
                          )}
                        </FormItem>
                      )
                    })}
                  </div>
                  <div style={{textAlign:'center',margin:'10px'}}>
                    {children}
                    {(type === 'update' || type ==='create') ?
                      <StyledButton type="submit">
                      Salvar
                      </StyledButton>
                      :
                      <>
                      </>
                    }
                  </div>
                </form>
              </CardContent>
            </Card>
          </Container>
      </Modal>
    </>
  );
}

export default ReadOrUpdateModal;